module.exports = __webpack_public_path__ + "img/banner02_img.13c3be25.png";